import { render } from "./CreateCombo.vue?vue&type=template&id=6961ee38&scoped=true"
import script from "./CreateCombo.vue?vue&type=script&lang=js"
export * from "./CreateCombo.vue?vue&type=script&lang=js"

import "./CreateCombo.vue?vue&type=style&index=0&id=6961ee38&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6961ee38"]])

export default __exports__